import { render, staticRenderFns } from "./NewTicketForm.vue?vue&type=template&id=4feb9034&scoped=true"
import script from "./NewTicketForm.vue?vue&type=script&lang=js"
export * from "./NewTicketForm.vue?vue&type=script&lang=js"
import style0 from "./NewTicketForm.vue?vue&type=style&index=0&id=4feb9034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb9034",
  null
  
)

export default component.exports